import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { AppUtils } from '../../../shared/utilities/app-utils';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { MatDialog } from '@angular/material/dialog';
import { EmailDeliveryDetailsComponent } from '../email-delivery-details/email-delivery-details.component';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'dl-email-delivery-table',
  templateUrl: './email-delivery-table.component.html',
  styleUrls: ['./email-delivery-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class EmailDeliveryTableComponent implements OnInit, OnChanges {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() emailTableData = [];
  dataSource = new MatTableDataSource<any>();
  displayedColumns = ['Country', 'Id', 'Name', 'Email', 'Date', 'Resend', 'Status'];
  searchBox = new FormControl();

  constructor(
    public appUtils: AppUtils,
    public changeDetectorRef: ChangeDetectorRef,
    public qnsbnService: QnSbnService,
    public readonly dialog?: MatDialog,
  ){}

  ngOnChanges(){
    this.dataSource.data = this.emailTableData;
    // Trigger change detection to ensure sorting works with new data
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    
    // Custom sorting data accessor to map column names to data properties
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string) => {
      switch (sortHeaderId) {
        case 'Id': return data.CustomerId;
        case 'Name': return data.CustomerName;
        case 'Country': return data.Country;
        case 'Email': return data.CustomerContactEmail;
        case 'Date': return new Date(data.Date);
        case 'Resend': return data.IsResend;
        case 'Status': return data.DeliveryStatus;
        default: return data[sortHeaderId];
      }
    };
  }

  searchText(searchValue: string): void {
    this.dataSource.filter = searchValue.trim().toLocaleLowerCase();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return this.appUtils.getLowerCase(data.Date).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.Country).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.CustomerContactEmail).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.CustomerId).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.DeliveryStatus).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.CustomerName).includes(filter.toLowerCase()) 
      || this.appUtils.getLowerCase(data.IsResend).includes(filter.toLowerCase());
    };
    this.changeDetectorRef.detectChanges();
  }

  emailDetails(row){
    this.dialog.open(EmailDeliveryDetailsComponent, { 
      data: JSON.stringify({ MessageId: row?.MessageId, CustomerContactEmail: row?.CustomerContactEmail }),
      disableClose: true
    });
  }

}
